import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";
import BlogCard from "../components/BlogCard";
import ProductCard from "../components/ProductCard";
import SpecialProduct from "../components/SpecialProduct";
import Container from "../components/Container";
import DataNotFound from "../components/DataNotFound";
import { services } from "../utils/Data";
import prodcompare from "../images/prodcompare.svg";
import wish from "../images/wish.svg";
import wishlist from "../images/wishlist.svg";
import addcart from "../images/add-cart.svg";
import view from "../images/view.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs } from "../features/blogs/blogSlice";
import moment from "moment";
import { getAllProducts, getAllCategory, getHomePageSlider, getHomePagePromoBanner } from "../features/products/productSlilce";
import ReactStars from "react-rating-stars-component";
import { addToWishlist } from "../features/products/productSlilce";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { getAllBrands } from "../features/brands/brandSlice";
import ImageCarousel from "../components/Carousal";
import CategoryCarousel from "../components/CategoryCarousal";
import ProductCardCommon from "../components/ProductCardCommon";
import Slider from "react-slick";
import { getTokenFromLocalStorage } from "../components/commonData";
import { toast } from "react-toastify";
import cart from "../images/cart.svg";
import "./home.css";
import { addProdToCart } from "../features/user/userSlice";
import OfferPopup from "../components/OfferPopup";
import ApiResponseModal from "../components/ApiResponseModal";
const NextArrow = ({ onClick, className, style }) => (
  <div
    className={`slick-arrow-next ${className || ''}`}
    onClick={onClick}
    style={style}
    aria-label="Next"
  >
    <img src="https://www.iconpacks.net/icons/2/free-arrow-right-icon-3098-thumb.png" alt="next" />
  </div>
);

const PrevArrow = ({ onClick, className, style }) => (
  <div
    className={`slick-arrow-prev ${className || ''}`}
    onClick={onClick}
    style={style}
    aria-label="Previous"
  >
    <img src="https://www.iconpacks.net/icons/2/free-arrow-left-icon-3099-thumb.png" alt="prev" />
  </div>
);


const Home = ({fetchCart,fetchWishlist}) => {
  const blogState = useSelector((state) => state?.blog?.blog);
  const productState = useSelector((state) => state?.product?.product);
  const sliderState = useSelector((state) => state?.product?.slider);
  const promoBannerState = useSelector((state) => state?.product?.promoBanner);
  const brandList = useSelector((state) => state?.brand);
  const categoryList = useSelector((state) => state?.product?.category || []);
  const isLoading = useSelector((state) => state?.product?.isLoading);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = window.innerWidth < 768;

 const state = useSelector((state) => state.user);
  const [apiModal, setApiModal] = useState({
  show: false,
  type: "success",
  title: "",
  message: "",
});



// Fixed slider settings - always shows 4 cards
const sliderSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  swipe: true,
  swipeToSlide: true,
  centerMode: false,
  arrows: true,
  // nextArrow: <NextArrow />,
  // prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        rows: 2,
        slidesPerRow: 2,
        arrows: false,
        dots: false,
      },
    },
  ],
};

// // Function to pad products array with disabled cards if less than 4
// const padProductsWithDisabled = (products) => {
//   const paddedProducts = [...products];
//   const needed = 6 - products.length;
  
//   if (needed > 0) {
//     for (let i = 0; i < needed; i++) {
//       paddedProducts.push({
//         _id: `disabled-${i}`,
//         isDisabled: true,
//       });
//     }
//   }
  
//   return paddedProducts;
// };

// Pad only when products are 4 or more
const padProductsWithDisabled = (products) => {
  // ❌ Do nothing if less than 4 products
  if (products.length < 4) {
    return products;
  }

  const paddedProducts = [...products];
  const needed = 6 - products.length;

  if (needed > 0) {
    for (let i = 0; i < needed; i++) {
      paddedProducts.push({
        _id: `disabled-${i}`,
        isDisabled: true,
      });
    }
  }

  return paddedProducts;
};



 const bestSellerData = Array.isArray(productState)
  ? productState?.filter((item) => item.tags)
  : [];
  useEffect(() => {
    dispatch(getHomePageSlider());
    dispatch(getHomePagePromoBanner());
    getblogs();
    getProducts();
    getBrands();
    getCategories();
    
  }, []);
  const getblogs = () => {
    dispatch(getAllBlogs());
  };

  const getProducts = () => {
    dispatch(getAllProducts());
  };
  const getBrands = () => {
    dispatch(getAllBrands());
  }
  const getCategories = () => {
    dispatch(getAllCategory());
  }

  // Get categories that have products
  const categoriesWithProducts = Array.isArray(categoryList) && Array.isArray(productState)
    ? categoryList.filter(category => {
        return productState.some(product => product.category === category.unique_slug);
      })
    : [];

const addToWish = async (id) => {
  if (!getTokenFromLocalStorage) {
    setApiModal({
      show: true,
      type: "info",
      title: "Login Required",
      message: "Please login first to add items to wishlist",
    });
    return;
  }

  try {
    const resultAction = await dispatch(addToWishlist(id));

    // ✅ Success
    if (addToWishlist.fulfilled.match(resultAction)) {
      setApiModal({
        show: true,
        type: "success",
        title: "Added to Wishlist",
        message: "Product added to your wishlist successfully",
      });

      fetchWishlist(); // ✅ no timeout
    }

    // ❌ Rejected
    if (addToWishlist.rejected.match(resultAction)) {
      setApiModal({
        show: true,
        type: "error",
        title: "Failed",
        message:
          resultAction.error?.message ||
          "Unable to add product to wishlist",
      });
    }
  } catch (err) {
    setApiModal({
      show: true,
      type: "error",
      title: "Error",
      message: "Something went wrong. Please try again.",
    });
  }
};

const addCart = async (item) => {
  try {
    const resultAction = await dispatch(
      addProdToCart({
        productId: item?._id,
        quantity: 1,
        color: item?.color?.[0],
        price: item?.current_price,
      })
    );

    // ✅ Check success (RTK standard)
    if (addProdToCart.fulfilled.match(resultAction)) {
      // dispatch(
        setApiModal({
          show: true,
          type: "success",
          title: "Added to Cart",
          message: "Product added to cart successfully",
        })
      // );

      fetchCart(); // no timeout needed
    }

    // ❌ Optional: handle rejected
    if (addProdToCart.rejected.match(resultAction)) {
      // dispatch(
        setApiModal({
          show: true,
          type: "error",
          title: "Failed",
          message:
            resultAction.error?.message ||
            "Unable to add product to cart",
        })
      // );
    }
  } catch (err) {
    // dispatch(
      setApiModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Something went wrong. Please try again.",
      })
    // );
  }
};



  // Show DataNotFound if no data is available (after loading is complete)
  // if (!isLoading && !hasProducts && !hasCategoriesWithProducts && !hasTrendingProducts && !hasBestSellerProducts && !hasNewArrivalProducts) {
  //   return <DataNotFound />;
  // }
  return (
    <>
    <ApiResponseModal
  show={apiModal.show}
  type={apiModal.type}
  title={apiModal.title}
  message={apiModal.message}
  onClose={() =>
    setApiModal((prev) => ({ ...prev, show: false }))
  }
/>

       <OfferPopup
        id="first-visit-offer-50"
        title="Welcome to Shoplintic 🎉"
        description="Flat 50% OFF on your first order. Hurry, limited time!"
        coupon="OFF50"
        buttonText="Shop Now"
        buttonLink="/product"
      />
      
      <Container class1="home-wrappe">
        <div className="row">
          <ImageCarousel list={sliderState} />
        </div>
      </Container>
     
<Container class1="home-wrapper-2 py-4">
  <div className="row g-3">
    {categoryList?.map((i, j) => (
      <div
        className="col-6 col-md-4 col-lg-3"
        key={j}
        onClick={() =>
          navigate(`/product?category=${i?.unique_slug}`)
        }
      >
        <div className="category-card">
          <div className="category-img">
            <img src={i.img_url} alt={i.title} />
          </div>

          <h6 className="category-title">{i.title}</h6>
        </div>
      </div>
    ))}
  </div>
</Container>

      {/* <Container class1="famous-wrapper py-1 home-wrapper-2">
  <div className="row">
    {promoBannerState.slice(0,3).map((item, index) => (
      <div className="col-lg-4 col-md-6 col-sm-12 mb-3" key={index} onClick={()=>{
            navigate(`/product?category=${item?.link}`);
      }}>
        <div className="famous-card position-relative">
          <img src={item.image} className="img-fluid w-100" alt="famous" />
          <div className="famous-content position-absolute">
            <h5 className={item.textDark ? "text-dark" : ""}>{item.brand}</h5>
            <h6 className={item.textDark ? "text-dark" : ""}>{item.title}</h6>
            <p className={item.textDark ? "text-dark" : ""}>{item.subtitle}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</Container> */}

      {productState && productState.length > 0 ? (
        productState.map((categoryItem, categoryIndex) => {
          const products = categoryItem?.products || [];
          if (products.length === 0) return null;

          return (
            <Container
              key={categoryIndex}
              class1="featured-wrapper home-wrapper-2"
            >
              {/* SECTION HEADER */}
              <div className="section-header">
                <h4>{categoryItem.category}</h4>
                <span
                  className="view-all"
                  onClick={() =>
                    navigate(`/product?category=${categoryItem.category}`)
                  }
                >
                  View all
                </span>
              </div>

              {/* SLIDER */}
           {/* PRODUCT LIST / SLIDER */}
<div className="product-slider">
  {!isMobile ? (
    /* DESKTOP: USE SLIDER */
    <Slider {...sliderSettings}>
      {padProductsWithDisabled(products).map((product, index) => (
        <div key={index} className="px-2">
          {product.isDisabled ? (
            <div className="product-card disabled-card" style={{ height: "210px", minHeight: "100px" }}>
              <div className="product-image disabled-image">Coming Soon</div>
              <div className="product-details flex-grow-1">
                <h6 className="product-title muted">Product Unavailable</h6>
              </div>
            </div>
          ) : (
            <ProductCardCommon
              index={index}
              item={product}
              wish={wish}
              navigate={navigate}
              addToWish={addToWish}
              prodcompare={prodcompare}
              wishlist={wishlist}
              addcart={addCart}
              view={view}
            />
          )}
        </div>
      ))}
    </Slider>
  ) : (
    /* MOBILE: SIMPLE GRID, NO SLIDER */
    <div className="row gx-2 gy-3">
      {products.map((product, index) => (
        <div key={index} className="col-6">
          <ProductCardCommon
            index={index}
            item={product}
            wish={wish}
            navigate={navigate}
            addToWish={addToWish}
            prodcompare={prodcompare}
            wishlist={wishlist}
            addcart={addCart}
            view={view}
          />
        </div>
      ))}
    </div>
  )}
</div>

            </Container>
          );
        })
      ) : (
        <Container class1="featured-wrapper home-wrapper-2">
          <div className="row">
            <div className="col-12 text-center py-5">
              <h5>No Products Available</h5>
              <p className="text-muted">
                Products will appear here once they are added.
              </p>
            </div>
          </div>
        </Container>
      )}
       <Container class1="famous-wrapper py-1 home-wrapper-2">
  <div className="row">
    {promoBannerState.slice(3,6).map((item, index) => (
      <div className="col-lg-4 col-md-6 col-sm-12 mb-3" key={index} onClick={()=>{
            navigate(`/product?category=${item?.link}`);
      }}>
        <div className="famous-card position-relative">
          <img src={item.image} className="img-fluid w-100" alt="famous" />
        <div className="famous-content position-absolute">
  <h5 style={{ color: item.textColor }}>{item.brand}</h5>
  <h6 style={{ color: item.textColor }}>{item.title}</h6>
  <p style={{ color: item.textColor }}>{item.subtitle}</p>
</div>
        </div>
      </div>
    ))}
  </div>
</Container>



  
 


     
  

       

   <Container class1="home-wrapper-1 py-4">
        <div className="row">
          <CategoryCarousel categoryList={categoryList} />
        </div>
      </Container>
    </>
  );
};

export default Home;
